import React from 'react';
import { Box,CssBaseline, Container, Grid, Typography, TextField, Button, Link, IconButton, Paper } from '@material-ui/core';
import { Twitter, LinkedIn, GitHub, Extension } from '@material-ui/icons';
import { useDescope } from '@descope/react-sdk';
import { useEffect,useState } from 'react';

import Logo from './keyrunnerlogo.png';




export function LoginForm({ email, setEmail, handleLoginClick, errorMessage,infoMessage,isLoading,showSessionInfo,setShowSessionInfo,setCookie }) {
  const descopeSdk = useDescope();
  const [urlErrorMessage, setUrlErrorMessage] = useState('');
  

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const urlError = query.get('err');

    if (urlError) {
      // Logout and clear session info
      descopeSdk.logoutAll();
      setCookie('userEmail', '', { path: '/' });
      setShowSessionInfo(false);
      setEmail('');

      if (urlError === 'User is disabled') {
        setUrlErrorMessage('Your account has been disabled by your organization. Please contact your tenant admin.');
      } else {
        setUrlErrorMessage(decodeURIComponent(urlError));
      }
    }
  }, []);

  if (urlErrorMessage) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7fa' }}>
        <Paper style={{ padding: 32, maxWidth: 400 }}>
          <img src={Logo} alt="Logo" style={{ maxWidth: '60%', marginBottom: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
          <Typography variant="h6" align="center" color="error">
            {urlErrorMessage}
          </Typography>
          <Typography variant="body2" align="center" style={{ marginTop: 16 }}>
            <Link href="mailto:support@keyrunner.app">Contact support</Link>
          </Typography>
        </Paper>
      </div>
    );
  }

  return (
    <>
      <CssBaseline />
      <div style={{ background: 'linear-gradient(to bottom, #f2f3f5, #0057f5)', minHeight: '100vh' }}>
  <Container maxWidth="lg">
    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
      <Paper elevation={3} style={{ padding: 20, maxWidth: 400 }}>
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <img src={Logo} alt="Logo" style={{ maxWidth: '80%', marginBottom: 0 }} />
          </Grid>

          {showSessionInfo ? (
            <>
              <Grid item>
                <Typography variant="h6" align="center">Welcome back</Typography>
              </Grid>
              <Grid item>
              <Typography variant="body1" align="center" style={{ color: '#444' }}>
              You're already logged in as<br />
              <span style={{ fontWeight: 600, fontSize: '1.05rem' }}>{email}</span>
            </Typography>

              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 20, marginBottom: 8,marginLeft:120 }}
                  onClick={handleLoginClick}
                >
                  Continue
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="text"
                  fullWidth
                  style={{ color: '#555', fontSize: '0.85rem', textTransform: 'none' }}
                  onClick={async () => {
                    const resp = await descopeSdk.logoutAll();
                    setCookie('userEmail', '', { path: '/' });
                    setShowSessionInfo(false);
                    setEmail('');
                    // setErrorMessage(null);
                    // setInfoMessage(null);
                  }}
                >
                   Not you? <strong>Switch user</strong>
                </Button>
              </Grid>
              <Grid item>
              <Typography
                variant="caption"
                align="center"
                color="textSecondary"
                style={{ marginTop: 12 }}
              >
                To switch accounts, you may need to sign out from your organization's SSO portal.
              </Typography>

              </Grid>
            </>
          ) : (
            <>
              <Grid item>
              <Box mb={3}>
                <Typography variant="body2" style={{ color: '#333', textAlign: 'center' }}>
                  Login with your organization email address.
                </Typography>
                <Typography variant="body2" style={{ color: '#555', textAlign: 'center' }}>
                  Personal addresses are not supported.
                </Typography>
              </Box>

              <Box mb={4}>
                <Typography variant="body2" style={{ textAlign: 'center', color: '#444' }}>
                  Don’t have an account?{' '}
                  <Link
                    href="https://keyrunner.app/Contactus"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#007aff', fontWeight: 500 }}
                  >
                   Get a demo Account
                  </Link>
                </Typography>
              </Box>

                </Grid>

              <form
                autoComplete="on"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLoginClick();
                }}
              >
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="username"
                    autoComplete="username"
                    inputProps={{ autoComplete: 'username' }}
                    fullWidth
                    label="Email"
                    defaultValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
              </form>

              {errorMessage && (
                <Grid item>
                  <Typography variant="body2" color="error" align="center" gutterBottom>
                    {errorMessage}
                  </Typography>
                </Grid>
              )}

              {infoMessage && (
                <Grid item>
                  <Typography variant="body2" style={{ color: '#17a2b8' }} align="center" gutterBottom>
                    {infoMessage}
                  </Typography>
                </Grid>
              )}

              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleLoginClick}
                  type="submit"
                  disabled={!email || isLoading}
                >
                  {isLoading ? 'Logging in...' : 'Login'}
                </Button>
              </Grid>
            </>
          )}

          <Grid item>
            <Typography variant="body2" align="center">
              By logging in, you agree to our <Link href="https://keyrunner.app/privacypolicy" target="_blank">Privacy Policy</Link>.
            </Typography>
          </Grid>

          <Grid item container justify="center" spacing={2}>
            <Grid item>
              <IconButton href="https://marketplace.visualstudio.com/items?itemName=KeyRunner.keyrunner" target="_blank">
                <Extension />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton href="https://www.linkedin.com/company/96955951/" target="_blank">
                <LinkedIn />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton href="https://twitter.com/keyRunnerApp" target="_blank">
                <Twitter />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton href="https://github.com/launchiamenterprise/keyrunner" target="_blank">
                <GitHub />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  </Container>
</div>

    </>
  );
};
